module.exports = __webpack_public_path__ + "img/banner-text.a0bb1d94.png";